import { t } from '@lingui/core/macro';
import { Trans } from '@lingui/react/macro';
import { Alert, Button } from '@pocketlaw/tetris';
import { useRole } from 'app/domains/users/hooks/useRole';
import { useGetLinks } from 'shared/domains/urls';
export function UpgradeAlert() {
    const role = useRole();
    const isOwner = role.is() === 'owner';
    const { pricing } = useGetLinks();
    if (isOwner) {
        return (<Alert appearance="warning" title={t({ message: 'Upgrade account', comment: 'Duplicate document dialog - Alert title - upgrade account' })} message={t({
                message: 'The contract template is not included in your current subscription.',
                comment: 'Duplicate document dialog - Upgrade alert - upgrade account message',
            })}>
        <Button as="a" href={pricing} appearance="secondary" size="small" target="_blank" rel="noopener noreferrer">
          <Trans comment="Upgrade alert button text">Upgrade</Trans>
        </Button>
      </Alert>);
    }
    return (<Alert appearance="warning" title={t({
            message: 'Missing access',
            comment: 'Duplicate document dialog - Alert title - duplicate document when lacking permission to composer',
        })} message={t({
            message: 'You do not have access to this contract template, contact your company owner.',
            comment: 'Duplicate document dialog - Alert body - duplicate document when lacking permission to composer',
        })}/>);
}
